import Vue from 'vue'
import Vuex from 'vuex'
import Vote from './modules/vote.js'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        loadStatus: false
    },
    mutations: {
        showLoading(state) {
            state.loadStatus = true;
        },
        closeLoading(state) {
            state.loadStatus = false;
        }
    },
    actions: {
        showLoading({
            commit
        }) {
            commit('showLoading');
        },
        closeLoading({
            commit
        }) {
            commit('closeLoading');
        }
    },
    modules: {
        Vote
    }
});
